import { useSelector } from 'react-redux'
import { currentRegion } from '@common/src/config/regions'

/**
 * Shows the region a sub-admin works in (from their account) when it isn't home.
 * Renders nothing (no header element) for home, so the home header is unchanged.
 */
const RegionBadge = () => {
  const { loading = true, user } = useSelector((state) => state.auth || {})
  if (loading || !user || currentRegion.isHome) return null

  return (
    <div className="header-element md:ps-[1.325rem] !items-center">
      <span className="badge rounded-pill bg-info text-white whitespace-nowrap" title="Region">
        {currentRegion.label}
      </span>
    </div>
  )
}

export default RegionBadge
